<template>
  <v-dialog v-model="show" max-width="1000px">
    <v-card>
      <v-card-text class="pa-4">
        <h2>{{ $t('Shipment routing tracking') }} {{ shipment.manifest }}</h2>

        <div class="data-container pa-4">
          <div class="text-xs-center" v-if="loading">
            <v-progress-circular
              indeterminate
            ></v-progress-circular>
          </div>

          <v-container class="pa-0" v-else>

            <template v-for="(item, idx) in items">
              <v-divider v-if="idx !== 0" class="divider"></v-divider>

              <v-layout row wrap :key="idx"
                class="fill-height align-start text-xs-left pa-2"
                :class="item.is_predicted ? 'bgr-false' : 'bgr-true'"
              >
              <!-- @click="$set(expanded, idx, !expanded[idx])" -->

                <v-flex xs2 sm1 class="align-self-center text-xs-center">
                  <v-tooltip bottom>
                    <v-avatar slot="activator" size="42" :color="item.is_predicted ? 'icon-false' : 'icon-true'">
                      <v-icon dark v-if="item.is_predicted">auto_graph</v-icon>
                      <v-icon dark v-else                  >local_shipping</v-icon>
                    </v-avatar>
                    {{ $t(item.is_predicted ? 'Predicted data' : 'Real data') }}
                  </v-tooltip>
                </v-flex>

                <v-flex xs10 sm5 class="layout align-baseline">
                  <span class="label-h">{{ $t('From')}}</span>
                  <span>{{ item.from }}</span>
                </v-flex>
                <v-flex xs10 offset-xs2 sm6 offset-sm0 class="layout align-baseline">
                  <span class="label-h">{{ $t('To')}}</span>
                  <span>{{ item.to }}</span>
                </v-flex>

                <v-flex xs12 md4>
                  <v-tooltip bottom>
                    <v-text-field
                      slot="activator"
                      :label="$t('Supplier')"
                      :value="item.supplier"
                      readonly
                      fill full-width hide-details
                      @click="copyArg(item.supplier, 'supplier' + idx)"
                      :class="fields['supplier' + idx]"
                    ></v-text-field>
                    <span>
                      {{ item.supplier }}
                      <v-icon small dark class="mx-2">content_copy</v-icon>
                      {{ labelClickToCopy }}
                    </span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs6 md4>
                  <v-tooltip bottom>
                    <v-text-field
                      slot="activator"
                      :label="$t('Supplier tax number')"
                      :value="item.supplier_tax_number"
                      readonly
                      fill full-width hide-details
                      @click="copyArg(item.supplier_tax_number, 'supplier_tax_number' + idx)"
                      :class="fields['supplier_tax_number' + idx]"
                    ></v-text-field>
                    <span>
                      {{ item.supplier_tax_number }}
                      <v-icon small dark class="mx-2">content_copy</v-icon>
                      {{ labelClickToCopy }}
                    </span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs6 md4>
                  <v-tooltip bottom>
                    <v-text-field
                      slot="activator"
                      :label="$t('Vehicle')"
                      :value="item.vehicle"
                      readonly
                      fill full-width hide-details
                      @click="copyArg(item.vehicle, 'vehicle' + idx)"
                      :class="fields['vehicle' + idx]"
                    ></v-text-field>
                    <span>
                      {{ item.vehicle }}
                      <v-icon small dark class="mx-2">content_copy</v-icon>
                      {{ labelClickToCopy }}
                    </span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-expand-transition>
                <v-layout row wrap :key="idx"
                  class="align-start text-xs-left"
                  :class="[item.is_predicted ? 'bgr-false' : 'bgr-true']"
                  v-show="expanded[idx]"
                >
                ---
                </v-layout>
              </v-expand-transition>
            </template>
          </v-container>

          <div ref="helper" />
        </div>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="show = false">{{ $t('Close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script type="text/javascript">
import { tracking } from '@/resources.js';

const UNSET = '-';

export default {
  props: ['value', 'shipment'],
  data() {
    return {
      show: this.value,
      loading: false,
      items: [],
      expanded: [],
      labelClickToCopy: this.$t('Click to copy'),
      fields: {}
    }
  },
  methods: {
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;

      const params = {
        id: this.shipment.id
      }

      tracking.route( params ).then(res => {

        if (res.body.segments) {
          let items = res.body.segments;
          items.forEach(item => {
            [
              'supplier',
              'supplier_tax_number',
              'vehicle'
            ].forEach(key => {
              if (!item[key]) {
                item[key] = UNSET;
              }
            });
          });
          this.items = items;
        }

      }, err => {

        console.log('routing tracking error:', err);
        this.$emit('msg-popup', extractErrors(err), 'error' );

      }).finally(() => {
        this.loading = false;
      });
    },
    copyArg(val, name) {
      const storage = document.createElement('textarea');
      storage.value = val;
      this.$refs.helper.appendChild(storage);
      storage.select();
      storage.setSelectionRange(0, 99999);
      document.execCommand('copy');
      this.$refs.helper.removeChild(storage);

      this.$set(this.fields, name, 'blink');
      setTimeout(() => this.fields[name] = '', 3000);
    }
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      if (val) {
        this.items = [];
        this.loadData();
      }
      this.$emit('show', val);
    }
  }
}
</script>

<style scoped>
.data-container {
  white-space: pre-wrap;
}
.bgr-true {
  background-color: #dfe893;
}
.bgr-false {
  background-color: #ffc792;
}
.icon-true {
  background-color: #8bc326;
}
.icon-false {
  background-color: #f07426;
}

.label-h {
  color: rgba(0,0,0,.54);
  font-size: 85%;
  margin-right: .5rem;
}
.divider {
  border-color: white;
  border-width: 2px;
}
>>> .blink {
  animation: blinker 1s step-start 2;
}
@keyframes blinker {
  50% {
    opacity: 0.1;
  }
}
</style>